
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1gp1v_1ki61_5",
  "control": "awsui_control_1gp1v_1ki61_6"
};
  